

import React from "react";
import myImage from "./images/exercise image.jpg";

export default function Tagline() {
  return (
    <div>
      <div className="container-fluid taglinecomp">
        <div className="row">
          <div className="col-sm-6 cp1 pt-2 text-center">
            <h1 className="healthheading">
              Your Ultimate Destination for{" "}
              <span className="spanhealthier"> Healthier You!</span>
            </h1>
            <br />
            <br />
            <h5>
            We believe that fitness should be fun and enjoyable. We foster a lively and inclusive space for you to unleash the full potential of your workouts with a diverse range of exercises meticulously curated for each muscle group.
            </h5>
            <br />
            <br />
            <h5>Join us today to be your go-to destination for muscle growth!</h5>
          </div>

          <div className="col-sm-6 cp2">
            <img
              src={myImage}
              alt="Description"
              className="img-fluid shadow rounded fit-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
